module.exports = __webpack_public_path__ + "assets/fd0ac6610aa44f6b17fc2ce290f8a9f0.mp3";